import React, { useContext } from 'react';

import { TooltipSource } from './FormFieldTooltip';
import FormMaskField from './FormMaskField';
import { FormProvider } from './FormProvider';
import { FieldEvent, FieldWidth } from './useFormField';

interface IProps {
  name: string;
  label?: string;
  tooltip?: TooltipSource;
  description?: string;
  disabled?: boolean;
  width?: FieldWidth;
  onFocus?: FieldEvent<string>;
  onChange?: FieldEvent<string>;
  onBlur?: FieldEvent<string>;
}

function FormPhoneField({ onChange, ...props }: IProps) {
  const { phoneMask } = useContext(FormProvider);
  const onChangeHandler = (
    value: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
  ) => {
    const valueFormatted = value.replace(/\D/gi, '');
    setFieldValue(props.name, valueFormatted);

    if (onChange) {
      onChange(valueFormatted, setFieldValue);
    }
  };

  return <FormMaskField {...props} mask={phoneMask} onChange={onChangeHandler} />;
}

export default FormPhoneField;
